import { useEffect } from "react";

const DEFAULT_TITLE = "Ouri Alkada — Senior Software Developer";

/** Keeps <title> and the meta description in step with the active route. */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    if (!description) return;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", description);
  }, [title, description]);
}
